import { pageEmbeddingIndexName } from '../db/embedding-schema'

export const NEMOTRON_EMBEDDING_MODEL = 'nvidia/Nemotron-3-Embed-8B'
export const NEMOTRON_EMBEDDING_DIMENSIONS = 4096
export const NEMOTRON_EMBEDDING_INDEX = { name: pageEmbeddingIndexName('pageTextEmbeddingNemotron', NEMOTRON_EMBEDDING_MODEL, NEMOTRON_EMBEDDING_DIMENSIONS), vectorFn: 'vector32', dimensions: NEMOTRON_EMBEDDING_DIMENSIONS } as const

export const EMBEDDING_PATH = '/embeddings'
// Version includes preprocessing, normalization and binary encoding, not just model identity.
export const EMBEDDING_VERSION = `${NEMOTRON_EMBEDDING_MODEL}:query-passage:l2:f32le:v1`
export const EMBEDDING_BYTES = NEMOTRON_EMBEDDING_DIMENSIONS * 4
export const QUERY_EMBEDDING_TIMEOUT_MS = 3_000
export type EmbeddingKind = 'query' | 'document'

export function encodeEmbeddingVector(vector: number[]): Uint8Array<ArrayBuffer> {
  if (vector.length !== NEMOTRON_EMBEDDING_DIMENSIONS || vector.some(value => !Number.isFinite(value))
    || !vector.some(value => value !== 0)) throw new Error('Invalid embedding vector')
  const bytes = new Uint8Array(EMBEDDING_BYTES)
  const view = new DataView(bytes.buffer)
  for (let index = 0; index < vector.length; index++) {
    view.setFloat32(index * 4, vector[index], true)
    if (!Number.isFinite(view.getFloat32(index * 4, true))) throw new Error('Invalid Float32 embedding')
  }
  return bytes
}

export function decodeEmbeddingVector(buffer: ArrayBuffer): number[] {
  if (buffer.byteLength !== EMBEDDING_BYTES) throw new Error('Invalid embedding byte length')
  const view = new DataView(buffer)
  const vector = Array.from({ length: NEMOTRON_EMBEDDING_DIMENSIONS }, (_, index) => view.getFloat32(index * 4, true))
  if (vector.some(value => !Number.isFinite(value)) || !vector.some(value => value !== 0)) throw new Error('Invalid embedding vector')
  return vector
}
